import React from "react";
import { Label } from "reactstrap";
import Required from "./Required";
import { get } from "react-hook-form";
const MyInput = ({
  title,
  name,
  register,
  trigger,
  errors,
  setValue,
  placeholder,
  required,
  min,
  max,
  disabled,
  inputPattern,
  pattern,
  patternMsg,
}) => {
  const error = get(errors, name);
  return (
    <div className="form-group my-2">
      <Label className="form-label" htmlFor={name}>
        {title}
        {required && title && <Required />}
      </Label>
      <div className="form-control-wrap">
        <input
          placeholder={placeholder}
          type="text"
          id={name}
          {...register(name, {
            required: required
              ? {
                  value: true,
                  message: `${title || name} is required`,
                }
              : false,
            pattern: {
              value: pattern,
              message: patternMsg,
            },
            minLength: min
              ? {
                  value: min,
                  message: `${title || name} must be at least ${min} characters`,
                }
              : undefined,
            maxLength: max
              ? {
                  value: max,
                  message: `${title || name} must be at most ${max} characters`,
                }
              : undefined,
          })}
          className={`form-control ${error ? "is-invalid" : ""}`}
          onChange={(e) => {
            e.target.value = e.target.value.replace(inputPattern, ""); // Remove non-numeric characters
            setValue(name, e.target.value, { shouldValidate: true });
          }}
          disabled={disabled}
        />
        {error && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {error.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MyInput;
